import React, { useState, useEffect, useContext, Fragment } from "react";
import { LogoImage, NavLinks } from "@/data";
import { Col, Container, Row } from "react-bootstrap";
import { SearchContext } from "@/context/search-context";
import { MenuContext } from "@/context/menu-context";
import { Link } from "gatsby";
import axios from "axios";

function getCurrentSeason() {
  const now = new Date();

  const seasons = {
    spring: {
      start: new Date(now.getFullYear(), 2, 20),
      end: new Date(now.getFullYear(), 5, 20),
    },
    summer: {
      start: new Date(now.getFullYear(), 5, 21),
      end: new Date(now.getFullYear(), 8, 22),
    },
    fall: {
      start: new Date(now.getFullYear(), 8, 23),
      end: new Date(now.getFullYear(), 11, 20),
    },
    winter: {
      start: new Date(now.getFullYear(), 11, 21),
      end: new Date(now.getFullYear() + 1, 2, 19),
    },
  };

  for (const [season, { start, end }] of Object.entries(seasons)) {
    if (now >= start && now <= end) {
      return season;
    }
  }

  // If the current date does not match any season range (this should not happen with correct date ranges)
  return null;
}
const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowDimensions;
};
const HeaderOne = () => {
  const [sticky, setSticky] = useState(false);
  const { searchStatus, updateSearchStatus } = useContext(SearchContext);
  const { menuStatus, updateMenuStatus } = useContext(MenuContext);
  const [isOpen, setIsOpen] = useState(true);
  const [hours, setHours] = useState("");
  const handleSearchClick = e => {
    e.preventDefault();
    updateSearchStatus(!searchStatus);
  };
  const handleMenuClick = e => {
    e.preventDefault();
    updateMenuStatus(!menuStatus);
  };

  const handleScroll = () => {
    if (window.scrollY > 70) {
      setSticky(true);
    } else if (window.scrollY < 70) {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [sticky]);

  useEffect(() => {
    const fetchPlace = async () => {
      const { data } = await axios.get(
        "https://rghl9zjzbj.execute-api.us-east-1.amazonaws.com/google_places_api"
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      );
      const dateNum = new Date(Date.now()).getDay();
      const hoursObj = data.opening_hours.periods[dateNum];
      const weekdayText = data.opening_hours.weekday_text;
      weekdayText.unshift(weekdayText[6]);
      weekdayText.pop();
      const dayText = weekdayText[dateNum];
      const openNow = data.opening_hours.open_now;
      setHours(dayText);
      setIsOpen(openNow);
      const open = hoursObj.open.time;
      const close = hoursObj.close.time;
      // const readOpen =
      //   parseInt(open) - 1200 > 0
      //     ? `${parseInt(open) - 1200} PM`
      //     : `${parseInt(open)} AM`;
      // const readClose =
      //   parseInt(close) - 1200 > 0
      //     ? `${parseInt(close) - 1200} PM`
      //     : `${parseInt(close)} AM`;

      console.log("the response", dayText, data);
    };
    fetchPlace();
  }, []);

  return (
    <Fragment>
      <header
        className={`header_01 ${
          true === sticky ? "fixedHeader animated flipInX" : null
        }`}
        id="header"
        style={{
          backgroundColor: "black",
          padding: 10,
          height: 100,
          position: "fixed",
        }}
      >
        <Container fluid>
          <Row
            className="justify-content-between"
            style={{ flexWrap: "nowrap" }}
          >
            <Col className="col-6" lg={2} md={3} sm={3}>
              <div className="logo" style={{ padding: 0 }}>
                <Link to="/">
                  <img src={LogoImage.light} alt="" />
                  <div style={{ paddingInline: 5 }}>
                    <p
                      style={{
                        color: "white",
                        fontFamily: "Times New Roman",
                        fontSize: 11,
                        margin: 0,
                        lineHeight: "normal",
                      }}
                    >
                      {hours}
                    </p>
                    {isOpen ? (
                      <p
                        style={{
                          margin: 0,
                          padding: 0,
                          color: "green",
                          fontFamily: "Times New Roman",
                          fontSize: 11,
                          lineHeight: "normal",
                        }}
                      >
                        Currently Open
                      </p>
                    ) : (
                      <p
                        style={{
                          margin: 0,
                          padding: 0,
                          color: "red",
                          fontFamily: "Times New Roman",
                          fontSize: 11,
                          lineHeight: "normal",
                        }}
                      >
                        Currently Closed
                      </p>
                    )}
                  </div>
                </Link>
              </div>
            </Col>
            <Col
              lg={8}
              sm={8}
              md={7}
              // className="d-none d-lg-block "
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <nav
                className="mainmenu text-center mobile-hide"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <ul
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-evenly",
                    padding: 0,
                  }}
                >
                  {NavLinks.map((links, index) => {
                    return (
                      <li
                        style={{ padding: 0 }}
                        key={index}
                        className={`${
                          undefined !== links.subItems
                            ? "menu-item-has-children"
                            : ""
                        }`}
                      >
                        <Link to={links.url}>{links.name}</Link>
                        {undefined !== links.subItems ? (
                          <ul className="sub-menu">
                            {links.subItems.map((subLinks, index) => (
                              <li key={index}>
                                <Link to={subLinks.url}>{subLinks.name}</Link>
                              </li>
                            ))}
                          </ul>
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </Col>
            <Col
              // lg={2}
              // md={2}
              // sm={4}
              className="col-6"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                // padding: 0,
                flex: 1,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {/* <a
                className="search searchToggler"
                href="#"
                onClick={handleSearchClick}
              >
                <i className="mei-magnifying-glass"></i>
              </a> */}
                <a
                  href="#"
                  className="menu mobilemenu d-none d-md-none d-lg-none"
                  style={{ color: "white" }}
                >
                  <i style={{ color: "white" }} className="mei-menu"></i>
                </a>
                <a
                  id="open-overlay-nav"
                  className="menu hamburger"
                  onClick={handleMenuClick}
                  href="#"
                  style={{ color: "white" }}
                >
                  <i className="mei-menu"></i>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
        <div
          style={{
            height: 30,
            position: "fixed",
            top: 100,
            transform: "translateX(-10px)",
            backgroundColor: isOpen ? "green" : "red",
            width: "calc(100% + 20px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isOpen ? (
            <p style={{ height: "100%", margin: 0, color: "white" }}>
              We are open today!
            </p>
          ) : (
            <p style={{ height: "100%", margin: 0, color: "white" }}>
              We are closed. Come back at 9 AM!
            </p>
          )}
        </div>
      </header>
    </Fragment>
  );
};

export default HeaderOne;
